import { TranslateService } from "@ngx-translate/core";
import { IndicatorItem } from "@typings/step-indicator-item.type";

export const stepFactory: (translate: TranslateService) => IndicatorItem[] = (translate: TranslateService) => [
    {text: translate.instant('components.step_indicator.ergonomics'), value: 'ergonomics'},
    {text: translate.instant('components.step_indicator.centration'), value: 'centration'},
    {text: translate.instant('components.step_indicator.refraction'), value: 'refraction'},
    {text: translate.instant('components.step_indicator.summary'), value: 'summary'},
];